import { List, ListItem, ListItemText } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import styles from "../index.module.scss";
import Layout from "../../components/Layout";

const PigsMain = () => {
  const pigRoutes = ["Pigs", "Reproduction", "Births", "Weighting", "Deaths"];
  const router = useLocation();
  const pathName = router.pathname;

  return (
    <Layout>
      <List className="page_nav">
        {pigRoutes.map((route) => (
          <ListItem
            key={route}
            component={Link}
            to={`/pigs/${route.toLowerCase()}`}
            className="flex-1"
            selected={`/pigs/${route.toLowerCase()}` === pathName}
            classes={{ root: styles.root, selected: styles.listItemSelected }}
          >
            <ListItemText primary={route} className={styles.listItemText} />
          </ListItem>
        ))}
      </List>
      <Outlet />
    </Layout>
  );
};

export default PigsMain;
